import { Box, Button, Chip, Grid, Typography } from '@mui/material';
import { getDefaultImageSrc, loadDefaultImageOnError } from '../../utils/image';
import { formatToNepaliNumber, formatToNepaliPrice } from '../../utils/text';
import { isProgramApplyItem } from './helper';
import { applyScreenStyles } from './styles';
import { SelectedApplyItem } from './types';

interface PreviewApplyItemProps {
  onRemove: () => void;
  item: SelectedApplyItem;
}
export const PreviewApplyItem: React.FC<PreviewApplyItemProps> = ({ onRemove, item }) => {
  const isProgram = isProgramApplyItem(item);
  const imageUrl = isProgram
    ? item.providers?.media || getDefaultImageSrc('institute')
    : item.media || getDefaultImageSrc('scholarship');
  const imageAlt = isProgram ? item.providers?.name : item.title;
  const title = isProgram ? item.name : item.title;
  const instituteName = isProgram ? item.providers?.name : item.provider?.name;
  const address = isProgram ? item.providers?.address : item.provider?.address;
  const amount = isProgram ? item.fees : item.total_worth;
  const discount = isProgram && item.discount;
  const selectedProgramName =
    !isProgram &&
    item.selectedProgramId &&
    item.programs &&
    item.programs.find((program) => program.id.toString() === item.selectedProgramId?.toString())?.name;

  return (
    <Box sx={applyScreenStyles.previewCard}>
      <Grid alignItems="flex-end" justifyContent="space-between" container spacing={1}>
        <Grid item sm={9}>
          <Grid container alignItems="center" spacing={2.5}>
            <Grid item>
              <Box
                component="img"
                sx={[applyScreenStyles.previewCardImg, { objectFit: isProgram ? 'contain' : 'cover' }]}
                src={imageUrl}
                onError={loadDefaultImageOnError.bind(null, isProgram ? 'institute' : 'scholarship')}
                alt={imageAlt}
              />
            </Grid>
            <Grid item>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography sx={{ mb: 1.5 }} fontWeight="Bold">
                  {title}
                </Typography>
                {instituteName && (
                  <Typography sx={{ mb: 0.5 }} variant="medium" fontWeight="Medium" color="secondary">
                    {instituteName}
                  </Typography>
                )}
                {address && (
                  <Typography variant="medium" color="secondary">
                    {address}
                  </Typography>
                )}
                {selectedProgramName && (
                  <Typography variant="medium" color="secondary">
                    Selected Program:{' '}
                    <Typography variant="medium" fontWeight="Medium" color={(theme) => theme.palette.common.black}>
                      {selectedProgramName}
                    </Typography>
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
          {discount && discount.amount && discount.percentage && (
            <Box sx={{ mt: 1.5 }}>
              <Chip
                variant="light"
                color="success"
                sx={applyScreenStyles.discountBadge}
                label={`Scholarship: ${discount.percentage}% ( ${formatToNepaliPrice(discount.amount)} )`}
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={3}>
          <Box sx={applyScreenStyles.previewAmountSection}>
            {/* {amount && (
              <Box>
                <Typography variant="small" color="secondary">
                  Nrs.
                </Typography>
                <Typography variant="medium" fontWeight="Bold">
                  {formatToNepaliNumber(parseFloat(amount))}
                </Typography>
              </Box>
            )} */}
            <Button variant="default" size="small" color="error" onClick={onRemove}>
              Remove
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
